import { memo, forwardRef } from 'react';
import { View, Text, Pressable, StyleSheet, Image } from 'react-native';
import { TextInputPlain as TextInput } from '../components';

import { COLOR, FONT, FONT_SIZE, THEME, THEME_DARK, __WEB__ } from '../../constants/styles';

const StyledInput = forwardRef((props, ref) => {
  const editable = props.editable == null ? true : props.editable;
  const showSecureOption = props.secureTextEntry != null;
  return (
    <>
      <Text style={styles.labelText}>{__WEB__ || props.value ? props.label : ''}</Text>
      <View style={[styles.inputContainer, props.containerStyle]}>
        <TextInput
          ref={ref}
          style={styles.input}
          autoComplete={props.autoComplete || 'off'}
          editable={editable}
          autoFocus={!!props.autoFocus}
          placeholder={props.label}
          defaultValue={props.value}
          placeholderTextColor={COLOR.darkTheme.text}
          autoCorrect={!!props.autoCorrect}
          autoCapitalize={props.autoCapitalize || 'none'}
          keyboardType={props.keyboardType || 'default'}
          returnKeyType={props.returnKeyType || 'go'}
          selectTextOnFocus={true}
          clearButtonMode={props.clearButtonMode || 'while-editing'}
          onChangeText={props.onChangeText}
          onSubmitEditing={props.onSubmitEditing}
          underlineColorAndroid="transparent"
          secureTextEntry={!!props.secureTextEntry}
          testID={props.testID}
        />

        {!!showSecureOption && (
          <Pressable style={styles.showPasswordButton} onPress={props.onSecureTextButtonPress}>
            {!!props.secureTextEntry ? (
              <Image
                style={styles.showPasswordIcon}
                source={require('../../../resources/icon-eye.png')}
              />
            ) : (
              <Image
                style={styles.showPasswordIcon}
                source={require('../../../resources/icon-eye-invisible.png')}
              />
            )}
          </Pressable>
        )}
      </View>
    </>
  );
});

const styles = StyleSheet.create({
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: COLOR.darkTheme.text,
    marginBottom: 30,
  },
  input: __WEB__
    ? {
        ...THEME.input,
        borderBottomColor: COLOR.textLight,
        borderBottomWidth: 1,
      }
    : THEME_DARK.input,
  labelText: __WEB__
    ? THEME.labelText
    : {
        ...THEME.labelText,
        color: COLOR.darkTheme.text,
      },
  showPasswordButton: {
    paddingTop: 10,
    paddingLeft: 10,
  },
  showPasswordIcon: {
    width: 30,
    height: 27,
    tintColor: __WEB__ ? COLOR.textLight : COLOR.darkTheme.text,
  },
});

export default memo(StyledInput);
